module.exports = __webpack_public_path__ + "img/session_active.1207beb7.svg";